<script setup>
import { computed, inject } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';

const config = inject('config');
const productsStore = useProductsStore();

const props = defineProps(['tab', 'single', 'quoteLink']);

const hasPrice = computed(() => props.tab.details.price > 0);

const formattedPrice = computed(() => {
  if (hasPrice.value) {
    return props.tab.details.price.toLocaleString(productsStore.locales, {
      style: 'currency',
      currency: props.tab.details.currency,
    });
  } else {
    // when there's no price change 0 (zero) to local currency and replace it with "POA" text to get "£POA"
    return (0)
      .toLocaleString(productsStore.locales, {
        style: 'currency',
        currency: props.tab.details.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, config.POA)
      .trim();
  }
});
</script>

<template>
  <div
    class="c-product-card__tab"
    :class="{ 'c-product-card__tab--single': single }"
    itemprop="businessFunction"
  >
    <p class="c-product-card__tab-paragraph">{{ tab.description }}</p>
    <p class="c-product-card__tab-paragraph">
      {{ tab.details.beforePriceText }}
      <strong class="c-product-card__tab-price"
        >{{ formattedPrice }}
        <meta itemprop="price" :content="tab.details.price || config.POA" />
        <meta itemprop="priceCurrency" :content="tab.details.currency" />
      </strong>
      {{ tab.details.afterPriceText }}
    </p>
    <meta v-if="quoteLink" :content="quoteLink" itemprop="url" />
  </div>
</template>